import { initializeApp } from "@firebase/app"
import { getDatabase, ref, set } from "firebase/database"
import { useState } from "react"
import { FaPlusCircle } from "react-icons/fa"
import Select from "react-select"
import { CounterTypeMap, CounterTypes } from "../types/CounterTypes"
import { useNavigate } from "react-router"

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC-zsF1AdGcb5tg9Vo6bB1usgiK3VoiQ5c",
  authDomain: "kfk-environment.firebaseapp.com",
  databaseURL:
    "https://kfk-environment-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "kfk-environment",
  storageBucket: "kfk-environment.appspot.com",
  messagingSenderId: "209981891412",
  appId: "1:209981891412:web:dd288e5984c387af509ec1",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const db = getDatabase(app)

export default function Create() {
  const navigate = useNavigate()
  const [type, setType] = useState<undefined | CounterTypes>()
  const [loading, setLoading] = useState(false)

  const createCounter = async () => {
    setLoading(true)
    console.log("Creating counter")
    // Generate a random 7 character code
    const code = Math.random().toString(36).substring(2, 9)

    await set(ref(db, `counters/${code}`), CounterTypeMap[type!])
    navigate(`/${code}`)
  }

  return (
    <div className="bg-slate-900 w-full h-fit min-h-screen flex flex-col items-center justify-center">
      <div className="max-w-xs w-full flex flex-col gap-6 my-6">
        <h1 className="text-white text-3xl font-semibold">Skapa ny</h1>
        <Select
          onChange={(e) => setType(e?.value as CounterTypes)}
          options={[
            {
              value: "standard",
              label: "Standard",
            },
            { value: "extended", label: "Utökat" },
            { value: "tc-back", label: "TC + Baksida" },
            /*             {
              value: "baksida",
              label: "TC + Baksida",
            },
            {
              value: "framsida",
              label: "TC + Framsida",
            },
            {
              value: "framsida-baksida",
              label: "TC + Framsida + Baksida",
            }, */
          ]}
        />
        <button
          className="bg-green-500 text-white w-full rounded-lg h-16 flex justify-center items-center disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={!type || loading}
          onClick={createCounter}
        >
          <FaPlusCircle className="mr-2 h-5 w-5" /> Skapa ny
        </button>
      </div>
    </div>
  )
}
